/**
 * Stop the event propagation
 * @param {object} e - event object
 */
export default function stopPropagation(e) {
    if (e.nativeEvent) {
        e.nativeEvent.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }
    e.stopPropagation();

    return true; // Make it chainable with &&
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/stop-propagation.js